<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont el-icon-setting"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{$t('systemSetting.dySetting')}}</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <el-form @submit.native.prevent class="tableSearchForm" :inline="true" size="small" label-position="left">
                <div class="btn btn_active" style="margin-right: 10px" @click="add"><span>{{ $t('ems.add') }}</span></div>
                <el-form-item :label="$t('systemSetting.dyName')"><el-input v-model="form.envName" :placeholder="$t('systemSetting.dyTips')" style="width: 250px"></el-input></el-form-item>
                <div class="btn btn_active" @click="search"><i class="iconfont icon-sousuo"></i><span>{{ $t('ems.history.search') }}</span></div>
                <div class="btn btn_active" @click="reset"><i class="iconfont icon-reset"></i><span>{{ $t('ems.alarm.reset') }}</span></div>

                <div class="btn btn_active"  style="float:  right; width: 100px">
                    <el-button type="text" icon="el-icon-download" :loading="downloadLoading" @click="downLoad" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('index.export') }}</el-button>
                </div>
                <div class="btn btn_active"  style="float:  right; width: 100px">
                    <el-button type="text" icon="el-icon-upload" @click="handleUpload" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('index.upload') }}</el-button>
                </div>
                <div class="btn btn_active"  style="float:  right; width: 145px">
                    <el-button type="text" icon="el-icon-bottom" @click="handleCommand" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">设备拓扑下发</el-button>
                </div>
            </el-form>
            <el-table
                    :data="list"
                    style="width: 100%"
                    v-loading="listLoading"
                    border
                    size="small"
                    :height="756"
                    class="BMSTable"
            >
                <el-table-column  :label="$t('systemSetting.cnName')" align="center" prop="envName"  width="300"></el-table-column>
                <el-table-column  :label="$t('systemSetting.enName')" align="center"  prop="envNameEn"  width="300"></el-table-column>
                <el-table-column  :label="$t('systemSetting.bindDevice')" align="center"  prop="devices"></el-table-column>
                <el-table-column  :label="$t('ems.operate')" align="center" width="300">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="handleBindDevice(scope.row)" type="text" size="small" icon="el-icon-paperclip">{{$t('systemSetting.bindDevice')}}</el-button>
                        <el-button @click.native.prevent="handleEdit(scope.row)" type="text" size="small" icon="el-icon-edit-outline">{{$t('ems.edit')}}</el-button>
                        <el-button @click.native.prevent="handleCopy(scope.row.id)" type="text" size="small" icon="el-icon-edit-outline">{{$t('ems.strategy.Copy')}}</el-button>
                        <el-button @click.native.prevent="handleDelete(scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div v-if="addVisible">
            <el-dialog :title="activeRow.id ? $t('systemSetting.dyWinEdit'): $t('systemSetting.dyWinAdd')" :visible.sync="addVisible" append-to-body width="1600px" top="50px" :close-on-click-modal="false" custom-class="dialog-custom-class dialog-custom-class-min">
                <RingAdd :activeRow="activeRow"  @close="closePanel" :envSort="activeRow.envSort !== undefined ? activeRow.envSort : (total+1)"></RingAdd>
            </el-dialog>
        </div>

        <div v-if="uploadVis">
            <el-dialog :title="$t('index.upload')" :visible.sync="uploadVis" append-to-body width="800px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm"  size="small" label-width="150px" label-position="left" v-loading="uploadLoading">
                    <el-form-item :label="$t('index.upload')" style="margin-right: 100px">
                        <el-upload
                                ref="upload"
                                class="avatar-uploader-login"
                                action="/api/blade-wems/env/template/import"
                                name="jsonFile"
                                :multiple="false"
                                :show-file-list="true"
                                :headers="headers"
                                :auto-upload="false"
                                :limit="1"
                                :on-exceed="handleExceed"
                                :on-success="uploadSuccess"
                                :on-change="handleChange"
                                :on-error="handleError"
                                :before-upload="beforeAvatarUpload">
                            <i class="el-icon-upload avatar-uploader-icon"></i>
                            <div class="el-upload__tip" slot="tip"></div>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="uploadVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="submitUpload">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>

        <div v-if="bindVis">
            <el-dialog :title="$t('systemSetting.bindDevice')" :visible.sync="bindVis" append-to-body width="1000px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class dialog-custom-class-min">
               <Drag :id="activeRow.id"  @close="closePanel"></Drag>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { getEnvTemplateList, deleteTemp, copyTemp, TempDownload } from "@/api/spms";
    import { sendCommand2 } from "@/api/container";
    import  RingAdd from "./components/ringAdd";
    import  Drag from "./components/drag";

    import i18n from "@/lang";
    import { exportFile } from "@/utils/util";
    import { Base64 } from 'js-base64/base64';
    import spmsweb from '@/config/spmsweb';
    import { getStore } from "@/utils/store";

    export default {
        name: "mainSys",
        data(){
            return{
                opacity: 0,
                loading: false,
                size: 1000,
                page: 1,
                list: [],
                total: 0,
                listLoading: false,
                form: {},

                addVisible: false,

                activeRow: {},
                downloadLoading: false,
                uploadVis: false,
                uploadLoading: false,
                headers: {},
                fileList: [],
                bindVis: false,
            }
        },
        components: { RingAdd, Drag },
        computed: {
            ...mapGetters(["language"]),
        },
        created(){
            this.headers = {
                Authorization: `Basic ${Base64.encode(
                    `${spmsweb.clientId}:${spmsweb.clientSecret}`
                )}`,
                "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
                // 'Content-Type': 'application/json'
            };
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
            this.loadData();
        },
        methods: {
            handleBindDevice(row){
                this.activeRow =  row;
                this.bindVis = true;
            },
            search(){
                this.loadData();
            },
            loadData(){
                this.listLoading = true;
                const params = {... this.form};
                params.current = this.page;
                params.size = this.size;
                getEnvTemplateList(params).then(res => {
                    this.listLoading = false;
                    this.list = res.data.data || [];
                    this.total = this.list.length;
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err)
                });
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
            reset(){
                this.page= 1;
                this.form = {

                };
                this.loadData();
            },
            add(){
                this.activeRow = {};
                this.addVisible= true;
            },

            handleEdit(row){
                this.activeRow = JSON.parse(JSON.stringify(row));
                this.addVisible= true;
            },

            closePanel(isLoading){
                this.addVisible = false;
                this.bindVis = false;
                if(isLoading){
                    this.loadData();
                }
            },

            handleDelete(id){
                this.$confirm(i18n.t("systemSetting.ringRemoveTips"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    deleteTemp(id).then(() =>  {
                        this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
                        this.loadData();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },
            handleCopy(id){
                this.$confirm(i18n.t("systemSetting.ringCopyTips"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    copyTemp(id).then(() =>  {
                        this.$message.success(i18n.t("ems.SuccessfulOperation"));
                        this.loadData();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },

            submitUpload() {
                if (this.fileList.length === 0) {
                    this.$message.error("请选择文件！");
                    return;
                }
                this.$refs.upload.submit();
            },
            uploadSuccess(res) {
                if (res.success) {
                    this.$message.success(i18n.t("ems.SuccessfulOperation"));
                    this.uploadVis = false;
                    this.search();
                } else {
                    this.$refs.upload.clearFiles();
                    this.$message.error("上传文件失败！" +  res.msg);
                }
            },
            handleError(res) {
                console.log(JSON.stringify(res));
                this.$message.error("上传文件失败！");
            },
            beforeAvatarUpload(file) {
                console.log(file);

                return true;
            },
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
                    files.length + fileList.length
                        } 个文件`
                );
            },

            handleUpload(){
                this.uploadVis= true;
            },

            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },

            downLoad(){
                this.downloadLoading = true;
                const params = { ids: this.list.map(i => i.id).join(',') };
                TempDownload(params).then(res => {
                    this.downloadLoading = false;
                    this.$message.success("downloading");
                    let fileName = res.headers['content-disposition'];
                    fileName = fileName.slice(fileName.indexOf('=') + 1, fileName.indexOf('.')) + ".json";
                    exportFile(res.data, fileName,"application/octet-stream;charset=utf-8;charset=UTF-8;");
                }).catch(err => {
                    console.log(err);
                    this.downloadLoading = false;
                });
            },

            handleCommand(){
                this.$confirm(i18n.t("ems.strategy.sureyouwanttodothis"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    sendCommand2().then(() =>  {
                        this.$message.success(i18n.t("ems.SuccessfulOperation"));
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
        }
        .content{
            overflow: hidden;
            height: calc(100% - 52px);
            box-sizing: border-box;
            padding: 20px;

        }

    }
</style>
